export default function formatForAnaltyics(text: string) {
  return text.toLowerCase().split(' ').join('_');
}
